import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from '@/router'
import FBSignInButton from "vue-facebook-signin-button";
import "@/assets/styles/custom.scss";

Vue.use(FBSignInButton)

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
